import { Button } from '@cimplico/components';
import { useRefreshFYIDocuments } from '../../queries/use-refresh-fyi-documents';

type DocumentResyncProps = {
    workpaperId: string;
};

function DocumentResync({ workpaperId }: DocumentResyncProps): JSX.Element {
    const refreshQuery = useRefreshFYIDocuments();

    function refresh(): void {
        refreshQuery.mutate({
            workpaperId,
        });
    }

    return (
        <>
            <p className="text-sm text-gray-800 font-medium">Re-sync</p>
            <label className="text-sm text-gray-600 max-w-[80ch] block mb-2">
                Re-sync files in this job. Files referenced from entities or other jobs will also be re-synced.
            </label>
            <Button
                size="sm"
                label="Re-sync files"
                type="secondary"
                isLoading={refreshQuery.isLoading}
                disabled={refreshQuery.isLoading}
                onClick={refresh}
            />
        </>
    );
}

export default DocumentResync;
